/**
 * Transforma los dias a partir de los indices que se pasan y devuelve la abreviación y el nombre del día
 * @param {Number[]} indexDays - array de los indices de los dias (del 0 al 6)
 * @return {Array<{ abreviation: string, day: string }>} [{ abreviation, day }]
 */
export function transformIndexDays(indexDays) {
  const days = [
    { abreviation: "Lu", day: "Lunes" },
    { abreviation: "Ma", day: "Martes" },
    { abreviation: "Mi", day: "Miércoles" },
    { abreviation: "Ju", day: "Jueves" },
    { abreviation: "Vi", day: "Viernes" },
    { abreviation: "Sa", day: "Sábado" },
    { abreviation: "Do", day: "Domingo" },
  ];
  return days.filter((day, index) => indexDays.includes(index));
}
